import * as Yup from 'yup';

export const importUsersValidationSchema = Yup.object().shape({
  firstName: Yup.string().required('Required Field'),
  lastName: Yup.string().required('Required Field'),
  email: Yup.string().email('Invalid email address').required('Required Field'),
  phoneNumber: Yup.number().typeError('should be number').required('Required Field'),
});
